import React, { FC } from 'react';
import { useEnvironment, useTranslation } from '@wix/yoshi-flow-editor';
import { useSettings } from '@wix/tpa-settings/react';
import { TextButton } from 'wix-ui-tpa';
import { classes, st } from './MoreInfoButton.st.css';
import settingsParams from '../../../../../settingsParams';
import { DataHooks } from './consts';

export interface MoreInfoButtonProps {
  onClick: () => void;
}

export const MoreInfoButton: FC<MoreInfoButtonProps> = ({ onClick }) => {
  const { isMobile } = useEnvironment();
  const settings = useSettings();
  const { t } = useTranslation();

  return (
    <TextButton
      onClick={onClick}
      className={st(classes.root, { isMobile })}
      data-hook={DataHooks.ROOT}
    >
      {settings.get(settingsParams.moreInfoButtonText) ||
        t('info-card.design.more-info-label')}
    </TextButton>
  );
};
